module.exports = __webpack_public_path__ + "img/undraw-notify-88-a-4.ca2f87f5.svg";